import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MenuComponent } from './components/menu/menu.component';

import { UserAccessGuard } from '@library/modules/user';
import { AuthGuard } from '@library/modules/auth';
import {
   TermsViewComponent,
   TermsAgreeComponent
} from '@library/modules/menu';

export const appRoutes: Routes = [
   { path: '',
      component: MenuComponent,
      canActivate: [ AuthGuard ],
      canActivateChild: [ AuthGuard, UserAccessGuard ],
      children: [
         { path: 'terms', component: TermsViewComponent },
         {
            path: 'user',
            loadChildren: () => import( '@library/modules/user' ).then(m => m.UserModule),
            canLoad: [ AuthGuard ],
         },
         {
            path: 'shipments',
            loadChildren: () => import('@library/modules/shipments/shipments.module').then(m => m.ShipmentsModule),
            data: { access: 'tracking', allowNewAttachments: true },
            canLoad: [ AuthGuard ],
         },
         {
            path: 'shipment',
            loadChildren: () => import('./components/booking/booking.module').then(m => m.BookingModule),
            canLoad: [ AuthGuard ],
            data: { access: 'booking' },
         },
         {
            path: 'invoice',
            loadChildren: () => import('@library/modules/invoices').then(m => m.InvoicesModule),
            canLoad: [ AuthGuard ],
            data: { access: 'invoicing' },
         },
         {
            path: 'template',
            loadChildren: () => import('@library/modules/templates').then(m => m.TemplatesModule),
            canLoad: [ AuthGuard ],
            data: { access: 'booking' },
         },
         {
            path: 'report',
            loadChildren: () => import('@library/modules/reports').then(m => m.ReportsModule),
            canLoad: [ AuthGuard ],
            data: { access: 'tracking' },
         },
         {
            path: 'activityfeed',
            loadChildren: () => import('@library/modules/activityfeed').then(m => m.ActivityfeedModule),
            canLoad: [ AuthGuard ],
            data: { access: 'tracking' },
         },
         {
            path: 'addressbook',
            loadChildren: () => import('@library/modules/addressbook').then(m => m.AddressbookModule),
            canLoad: [ AuthGuard ],
            data: { access: 'booking' },
         }
      ]
   },

   { path: 'error', loadChildren: () => import( '@library/modules/errors' ).then( m => m.ErrorsModule )},
   { path: 'termsagree', component: TermsAgreeComponent },
   { path: 'redirect', loadChildren: () => import( '@library/modules/redirect' ).then( m => m.RedirectModule )},
   { path: '', loadChildren: () => import('@library/modules/login').then(m => m.LoginModule), },

   // default
   { path: '**', redirectTo: '' },
];

@NgModule({
   imports: [ RouterModule.forRoot(
      appRoutes,
      {
         // enableTracing: true,
         // onSameUrlNavigation: 'reload',
         scrollPositionRestoration: 'enabled',
      }
   )],
   exports: [ RouterModule ],
})
export class AppRoutingModule { }
